import React from "react";
import {brandAuthTheme} from "../../../constants/brandAuthTheme";
import {ThemeProvider} from "@mui/material/styles";
import BrandHeader from "./BrandHeader";
import BrandFooter from "./BrandFooter";
import BrandContent from "./BrandContent";
import Box from "@mui/material/Box";

export const AuthLayout:React.FunctionComponent<any> = ({ children }) => {
  return (
    <ThemeProvider theme={brandAuthTheme}>
      <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '100vh', background: '#F8FAFC' }}>
        <BrandHeader/>
        <BrandContent>
          {children}
        </BrandContent>
        <BrandFooter />
      </Box>
    </ThemeProvider>
  )
}

export default AuthLayout
